import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 204 204"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#F8F8F8",
      d: "M50.923 189.72c14.922 8.606 32.235 13.529 50.698 13.529 56.126 0 101.629-45.498 101.629-101.624S157.751 0 101.625 0 0 45.5 0 101.625c0 18.463 4.924 35.776 13.53 50.698l.033.058c.828 1.436 1.246 2.16 1.435 2.844.178.645.228 1.225.182 1.893-.049.718-.29 1.462-.787 2.95l-8.681 26.044-.01.034c-1.833 5.495-2.748 8.243-2.096 10.073a5.664 5.664 0 0 0 3.43 3.426c1.826.651 4.561-.261 10.032-2.084l.068-.026 26.044-8.681c1.483-.494 2.237-.745 2.953-.794a5.407 5.407 0 0 1 1.89.193c.686.19 1.41.608 2.853 1.44l.047.027Z"
    }, null, -1)
  ]))]))
}
export default { render: render }